export default __webpack_public_path__ + "static/media/iconDownloadApp.fae10101.svg";